//Retenciones ISR
//CxC
export const CXC_RETENCION_ISR_PROVEEDORES_ESTATALES = "CXC_RETENCION_ISR_PROVEEDORES_ESTATALES";
export const CXC_RETENCION_ISR_OTRAS_RETENCIONES = "CXC_RETENCION_ISR_OTRAS_RETENCIONES";
export const CXC_RETENCION_ISR_OTRAS_RENTAS = "CXC_RETENCION_ISR_OTRAS_RENTAS";

export const CXC_RETENCION_ISR_PROVEEDORES_ESTATALES_LABEL = "ISR-5% - Pago a Proveedores Estatales";
export const CXC_RETENCION_ISR_OTRAS_RETENCIONES_LABEL = "ISR-2% - Otras Retenciones";
export const CXC_RETENCION_ISR_OTRAS_RENTAS_LABEL = "ISR-10% - Otras Rentas";

export const CXC_RETENCION_ISR_PROVEEDORES_ESTATALES_VALOR = 5;
export const CXC_RETENCION_ISR_OTRAS_RETENCIONES_VALOR = 2;
export const CXC_RETENCION_ISR_OTRAS_RENTAS_VALOR = 10;

//CxP
export const CXP_RETENCION_ISR_ALQUILERES = "CXP_RETENCION_ISR_ALQUILERES";
export const CXP_RETENCION_ISR_HONORARIOS = "CXP_RETENCION_ISR_HONORARIOS";
export const CXP_RETENCION_ISR_PREMIOS_LOTERIA = "CXP_RETENCION_ISR_PREMIOS_LOTERIA";
export const CXP_RETENCION_ISR_TRANSFERENCIA_TITULOS = "CXP_RETENCION_ISR_TRANSFERENCIA_TITULOS";
export const CXP_RETENCION_ISR_DIVIDENDOS_PAGADOS = "CXP_RETENCION_ISR_DIVIDENDOS_PAGADOS";
export const CXP_RETENCION_ISR_INTERESES_PERS_JURI_NO_RESIDENTE_LEY_25312 = "CXP_RETENCION_ISR_INTERESES_PERS_JURI_NO_RESIDENTE_LEY_25312";
export const CXP_RETENCION_ISR_INTERESES_PERS_JURI_NO_RESIDENTE_LEY_572007 = "CXP_RETENCION_ISR_INTERESES_PERS_JURI_NO_RESIDENTE_LEY_572007";
export const CXP_RETENCION_ISR_INTERESES_PERS_FISI_NO_RESIDENTE_LEY_25312 = "CXP_RETENCION_ISR_INTERESES_PERS_FISI_NO_RESIDENTE_LEY_25312";
export const CXP_RETENCION_ISR_INTERESES_PERS_FISI_NO_RESIDENTE_LEY_572007_25312 = "CXP_RETENCION_ISR_INTERESES_PERS_FISI_NO_RESIDENTE_LEY_572007_25312";
export const CXP_RETENCION_ISR_REMESAS_AL_EXTERIOR = "CXP_RETENCION_ISR_REMESAS_AL_EXTERIOR";
export const CXP_RETENCION_ISR_PAGO_PROVEEDORES_ESTATALES = "CXP_RETENCION_ISR_PAGO_PROVEEDORES_ESTATALES";
export const CXP_RETENCION_ISR_JUEGOS_TELEFONICOS = "CXP_RETENCION_ISR_JUEGOS_TELEFONICOS";
export const CXP_RETENCION_ISR_GANANCIA_CAPITAL = "CXP_RETENCION_ISR_GANANCIA_CAPITAL";
export const CXP_RETENCION_ISR_OTRAS_RENTAS = "CXP_RETENCION_ISR_OTRAS_RENTAS";
export const CXP_RETENCION_ISR_OTRAS_RETENCIONES = "CXP_RETENCION_ISR_OTRAS_RETENCIONES";
export const CXP_RETENCION_ISR_PERSONAS_JURIDICAS = "CXP_RETENCION_ISR_PERSONAS_JURIDICAS";
export const CXP_RETENCION_ISR_INTERESES_PAGADOS = "CXP_RETENCION_ISR_INTERESES_PAGADOS";
export const CXP_RETENCION_ISR_SERVICIOS_TECNICOS = "CXP_RETENCION_ISR_SERVICIOS_TECNICOS";
export const CXP_RETENCION_ISR_DECRETO_13998 = "CXP_RETENCION_ISR_DECRETO_13998";

export const CXP_RETENCION_ISR_ALQUILERES_LABEL = "ISR-10% - Alquileres - COD. 1";
export const CXP_RETENCION_ISR_HONORARIOS_LABEL = "ISR-10% - Honorarios Por Servicio - COD. 2";
export const CXP_RETENCION_ISR_PREMIOS_LOTERIA_LABEL = "ISR-25% - Premios de Lotería - COD. 3";
export const CXP_RETENCION_ISR_TRANSFERENCIA_TITULOS_LABEL = "ISR-2% - Transferencia Títulos - COD. 4";
export const CXP_RETENCION_ISR_DIVIDENDOS_PAGADOS_LABEL = "ISR-10% - Dividendos - COD. 5";
export const CXP_RETENCION_ISR_INTERESES_PERS_JURI_NO_RESIDENTE_LEY_25312_LABEL = "ISR-10% - Intereses a Personas Jurídicas o Entidades no residentes (Ley 253-12) - COD. 6";
export const CXP_RETENCION_ISR_INTERESES_PERS_JURI_NO_RESIDENTE_LEY_572007_LABEL = "ISR-5% - Intereses a Personas Jurídicas o Entidades no residentes (Ley 57-2007) - COD. 7";
export const CXP_RETENCION_ISR_INTERESES_PERS_FISI_NO_RESIDENTE_LEY_25312_LABEL = "ISR-10% - Intereses a Personas Físicas no residentes (Ley 253-12) - COD. 8";
export const CXP_RETENCION_ISR_INTERESES_PERS_FISI_NO_RESIDENTE_LEY_572007_25312_LABEL = "ISR-5% - Intereses a Personas Físicas no residentes (Leyes 57-2007 y 253-12) - COD. 9";
export const CXP_RETENCION_ISR_REMESAS_AL_EXTERIOR_LABEL = "ISR-27% - Remesas - COD. 10";
export const CXP_RETENCION_ISR_PAGO_PROVEEDORES_ESTATALES_LABEL = "ISR-5% - Retención por pago proveedores del estado - COD. 12";
export const CXP_RETENCION_ISR_JUEGOS_TELEFONICOS_LABEL = "ISR-5% - Juegos Telefónicos (Norma 08-2011) - COD. 13";
export const CXP_RETENCION_ISR_GANANCIA_CAPITAL_LABEL = "ISR-1% - Ganancia de Capital (Norma 07-2011) - COD. 14";
export const CXP_RETENCION_ISR_OTRAS_RENTAS_LABEL = "ISR-10% - Otras Rentas - COD. 15";
export const CXP_RETENCION_ISR_OTRAS_RETENCIONES_LABEL = "ISR-2% - Otras Retenciones - COD. 16";
export const CXP_RETENCION_ISR_PERSONAS_JURIDICAS_LABEL = "ISR-1% - Intereses Pagados por Entidades Financieras a Personas Jurídicas Residentes (Norma 13-2011) - COD. 17";
export const CXP_RETENCION_ISR_INTERESES_PAGADOS_LABEL = "ISR-10% - Intereses Pagados por Entidades Financieras a Personas Físicas Residentes (Ley 253-12) - COD. 18";
export const CXP_RETENCION_ISR_SERVICIOS_TECNICOS_LABEL = "ISR-2% - Servicios Técnicos - COD. 16";
export const CXP_RETENCION_ISR_DECRETO_13998_LABEL = "ISR-2% - Retención Decreto 139-98 - COD. 16";

export const CXP_RETENCION_ISR_ALQUILERES_VALOR = 10;
export const CXP_RETENCION_ISR_HONORARIOS_VALOR = 10;
export const CXP_RETENCION_ISR_PREMIOS_LOTERIA_VALOR = 25;
export const CXP_RETENCION_ISR_TRANSFERENCIA_TITULOS_VALOR = 2;
export const CXP_RETENCION_ISR_DIVIDENDOS_PAGADOS_VALOR = 10;
export const CXP_RETENCION_ISR_INTERESES_PERS_JURI_NO_RESIDENTE_LEY_25312_VALOR = 10;
export const CXP_RETENCION_ISR_INTERESES_PERS_JURI_NO_RESIDENTE_LEY_572007_VALOR = 5;
export const CXP_RETENCION_ISR_INTERESES_PERS_FISI_NO_RESIDENTE_LEY_25312_VALOR = 10;
export const CXP_RETENCION_ISR_INTERESES_PERS_FISI_NO_RESIDENTE_LEY_572007_25312_VALOR = 5;
export const CXP_RETENCION_ISR_REMESAS_AL_EXTERIOR_VALOR = 27;
export const CXP_RETENCION_ISR_PAGO_PROVEEDORES_ESTATALES_VALOR = 5;
export const CXP_RETENCION_ISR_JUEGOS_TELEFONICOS_VALOR = 5;
export const CXP_RETENCION_ISR_GANANCIA_CAPITAL_VALOR = 1;
export const CXP_RETENCION_ISR_OTRAS_RENTAS_VALOR = 10;
export const CXP_RETENCION_ISR_OTRAS_RETENCIONES_VALOR = 2;
export const CXP_RETENCION_ISR_PERSONAS_JURIDICAS_VALOR = 1;
export const CXP_RETENCION_ISR_INTERESES_PAGADOS_VALOR = 10;
export const CXP_RETENCION_ISR_SERVICIOS_TECNICOS_VALOR = 2;
export const CXP_RETENCION_ISR_DECRETO_13998_VALOR = 2;

// Retenciones ITBIS
//CxC
export const CXC_RETENCION_ITBIS_30 = "CXC_RETENCION_ITBIS_30";
export const CXC_RETENCION_ITBIS_100 = "CXC_RETENCION_ITBIS_100";
export const CXC_RETENCION_ITBIS_100_NORMA_07_09 = "CXC_RETENCION_ITBIS_100_NORMA_07_09";

export const CXC_RETENCION_ITBIS_30_LABEL = "ITBIS-30%";
export const CXC_RETENCION_ITBIS_100_LABEL = "ITBIS-100%";
export const CXC_RETENCION_ITBIS_100_NORMA_07_09_LABEL = "ITBIS-100% Norma 07-09";

export const CXC_RETENCION_ITBIS_30_VALOR = 30;
export const CXC_RETENCION_ITBIS_100_VALOR = 100;

//CxP
export const CXP_RETENCION_ITBIS_30_VALOR = 30;
export const CXP_RETENCION_ITBIS_75_VALOR = 75;
export const CXP_RETENCION_ITBIS_100_VALOR = 100;

export const CXP_RETENCION_ITBIS_30 = "CXP_RETENCION_ITBIS_30";
export const CXP_RETENCION_ITBIS_75 = "CXP_RETENCION_ITBIS_75";
export const CXP_RETENCION_ITBIS_100 = "CXP_RETENCION_ITBIS_100";
export const CXP_RETENCION_ITBIS_100_NORMA_07_09 = "CXP_RETENCION_ITBIS_100_NORMA_07_09";

export const CXP_RETENCION_ITBIS_30_LABEL = "ITBIS-30%";
export const CXP_RETENCION_ITBIS_75_LABEL = "ITBIS-75%";
export const CXP_RETENCION_ITBIS_100_LABEL = "ITBIS-100%";
export const CXP_RETENCION_ITBIS_100_NORMA_07_09_LABEL = "ITBIS-100% Norma 07-09";

export const RETENCIONES_ISR_CXC_OPTIONS = [
    {
        value: CXC_RETENCION_ISR_PROVEEDORES_ESTATALES,
        label: CXC_RETENCION_ISR_PROVEEDORES_ESTATALES_LABEL,
        valor: CXC_RETENCION_ISR_PROVEEDORES_ESTATALES_VALOR
    },
    {
        value: CXC_RETENCION_ISR_OTRAS_RETENCIONES,
        label: CXC_RETENCION_ISR_OTRAS_RETENCIONES_LABEL,
        valor: CXC_RETENCION_ISR_OTRAS_RETENCIONES_VALOR
    },
    {
        value: CXC_RETENCION_ISR_OTRAS_RENTAS,
        label: CXC_RETENCION_ISR_OTRAS_RENTAS_LABEL,
        valor: CXC_RETENCION_ISR_OTRAS_RENTAS_VALOR
    },
];

export const RETENCIONES_ISR_CXP_OPTIONS = [
    {
        value: CXP_RETENCION_ISR_ALQUILERES,
        label: CXP_RETENCION_ISR_ALQUILERES_LABEL,
        valor: CXP_RETENCION_ISR_ALQUILERES_VALOR
    },
    {
        value: CXP_RETENCION_ISR_HONORARIOS,
        label: CXP_RETENCION_ISR_HONORARIOS_LABEL,
        valor: CXP_RETENCION_ISR_HONORARIOS_VALOR
    },
    {
        value: CXP_RETENCION_ISR_PREMIOS_LOTERIA,
        label: CXP_RETENCION_ISR_PREMIOS_LOTERIA_LABEL,
        valor: CXP_RETENCION_ISR_PREMIOS_LOTERIA_VALOR
    },
    {
        value: CXP_RETENCION_ISR_TRANSFERENCIA_TITULOS,
        label: CXP_RETENCION_ISR_TRANSFERENCIA_TITULOS_LABEL,
        valor: CXP_RETENCION_ISR_TRANSFERENCIA_TITULOS_VALOR
    },
    {
        value: CXP_RETENCION_ISR_DIVIDENDOS_PAGADOS,
        label: CXP_RETENCION_ISR_DIVIDENDOS_PAGADOS_LABEL,
        valor: CXP_RETENCION_ISR_DIVIDENDOS_PAGADOS_VALOR
    },
    {
        value: CXP_RETENCION_ISR_INTERESES_PERS_JURI_NO_RESIDENTE_LEY_25312,
        label: CXP_RETENCION_ISR_INTERESES_PERS_JURI_NO_RESIDENTE_LEY_25312_LABEL,
        valor: CXP_RETENCION_ISR_INTERESES_PERS_JURI_NO_RESIDENTE_LEY_25312_VALOR
    },
    {
        value: CXP_RETENCION_ISR_INTERESES_PERS_JURI_NO_RESIDENTE_LEY_572007,
        label: CXP_RETENCION_ISR_INTERESES_PERS_JURI_NO_RESIDENTE_LEY_572007_LABEL,
        valor: CXP_RETENCION_ISR_INTERESES_PERS_JURI_NO_RESIDENTE_LEY_572007_VALOR
    },
    {
        value: CXP_RETENCION_ISR_INTERESES_PERS_FISI_NO_RESIDENTE_LEY_25312,
        label: CXP_RETENCION_ISR_INTERESES_PERS_FISI_NO_RESIDENTE_LEY_25312_LABEL,
        valor: CXP_RETENCION_ISR_INTERESES_PERS_FISI_NO_RESIDENTE_LEY_25312_VALOR
    },
    {
        value: CXP_RETENCION_ISR_INTERESES_PERS_FISI_NO_RESIDENTE_LEY_572007_25312,
        label: CXP_RETENCION_ISR_INTERESES_PERS_FISI_NO_RESIDENTE_LEY_572007_25312_LABEL,
        valor: CXP_RETENCION_ISR_INTERESES_PERS_FISI_NO_RESIDENTE_LEY_572007_25312_VALOR
    },
    {
        value: CXP_RETENCION_ISR_REMESAS_AL_EXTERIOR,
        label: CXP_RETENCION_ISR_REMESAS_AL_EXTERIOR_LABEL,
        valor: CXP_RETENCION_ISR_REMESAS_AL_EXTERIOR_VALOR
    },
    {
        value: CXP_RETENCION_ISR_PAGO_PROVEEDORES_ESTATALES,
        label: CXP_RETENCION_ISR_PAGO_PROVEEDORES_ESTATALES_LABEL,
        valor: CXP_RETENCION_ISR_PAGO_PROVEEDORES_ESTATALES_VALOR
    },
    {
        value: CXP_RETENCION_ISR_JUEGOS_TELEFONICOS,
        label: CXP_RETENCION_ISR_JUEGOS_TELEFONICOS_LABEL,
        valor: CXP_RETENCION_ISR_JUEGOS_TELEFONICOS_VALOR
    },
    {
        value: CXP_RETENCION_ISR_GANANCIA_CAPITAL,
        label: CXP_RETENCION_ISR_GANANCIA_CAPITAL_LABEL,
        valor: CXP_RETENCION_ISR_GANANCIA_CAPITAL_VALOR
    },
    {
        value: CXP_RETENCION_ISR_OTRAS_RENTAS,
        label: CXP_RETENCION_ISR_OTRAS_RENTAS_LABEL,
        valor: CXP_RETENCION_ISR_OTRAS_RENTAS_VALOR
    },
    {
        value: CXP_RETENCION_ISR_OTRAS_RETENCIONES,
        label: CXP_RETENCION_ISR_OTRAS_RETENCIONES_LABEL,
        valor: CXP_RETENCION_ISR_OTRAS_RETENCIONES_VALOR
    },
    {
        value: CXP_RETENCION_ISR_PERSONAS_JURIDICAS,
        label: CXP_RETENCION_ISR_PERSONAS_JURIDICAS_LABEL,
        valor: CXP_RETENCION_ISR_PERSONAS_JURIDICAS_VALOR
    },
    {
        value: CXP_RETENCION_ISR_INTERESES_PAGADOS,
        label: CXP_RETENCION_ISR_INTERESES_PAGADOS_LABEL,
        valor: CXP_RETENCION_ISR_INTERESES_PAGADOS_VALOR
    },
    {
        value: CXP_RETENCION_ISR_SERVICIOS_TECNICOS,
        label: CXP_RETENCION_ISR_SERVICIOS_TECNICOS_LABEL,
        valor: CXP_RETENCION_ISR_SERVICIOS_TECNICOS_VALOR
    },
    {
        value: CXP_RETENCION_ISR_DECRETO_13998,
        label: CXP_RETENCION_ISR_DECRETO_13998_LABEL,
        valor: CXP_RETENCION_ISR_DECRETO_13998_VALOR
    },
];

export const RETENCIONES_ITBIS_CXC_OPTIONS = [
    {
        value: CXC_RETENCION_ITBIS_30,
        label: CXC_RETENCION_ITBIS_30_LABEL,
        valor: CXC_RETENCION_ITBIS_30_VALOR
    },
    {
        value: CXC_RETENCION_ITBIS_100,
        label: CXC_RETENCION_ITBIS_100_LABEL,
        valor: CXC_RETENCION_ITBIS_100_VALOR
    },
    {
        value: CXC_RETENCION_ITBIS_100_NORMA_07_09,
        label: CXC_RETENCION_ITBIS_100_NORMA_07_09_LABEL,
        valor: CXC_RETENCION_ITBIS_100_VALOR
    },
];

export const RETENCIONES_ITBIS_CXP_OPTIONS = [
    {
        value: CXP_RETENCION_ITBIS_30,
        label: CXP_RETENCION_ITBIS_30_LABEL,
        valor: CXP_RETENCION_ITBIS_30_VALOR
    },
    {
        value: CXP_RETENCION_ITBIS_75,
        label: CXP_RETENCION_ITBIS_75_LABEL,
        valor: CXP_RETENCION_ITBIS_75_VALOR
    },
    {
        value: CXP_RETENCION_ITBIS_100,
        label: CXP_RETENCION_ITBIS_100_LABEL,
        valor: CXP_RETENCION_ITBIS_100_VALOR
    },
    {
        value: CXP_RETENCION_ITBIS_100_NORMA_07_09,
        label: CXP_RETENCION_ITBIS_100_NORMA_07_09_LABEL,
        valor: CXP_RETENCION_ITBIS_100_VALOR
    },
];
